import { render, staticRenderFns } from "./price-super-sctipt.vue?vue&type=template&id=7a99f0cc&scoped=true"
import script from "./price-super-sctipt.vue?vue&type=script&lang=js"
export * from "./price-super-sctipt.vue?vue&type=script&lang=js"
import style0 from "./price-super-sctipt.vue?vue&type=style&index=0&id=7a99f0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99f0cc",
  null
  
)

export default component.exports